import React, { useState } from 'react';
import './PayrollSettings.css';

// 근무타입 하나(이름·색·근무시간표)를 고치는 카드. 근무타입 설정 탭과 임금대장 화면의 「+ 근무타입」이 같이 쓴다.

// 근무타입에 차례로 붙이는 파스텔 색 (백엔드 ledger.py 의 WORK_TYPE_COLORS 와 같은 목록·같은 순서)
export const WORK_TYPE_COLORS = [
  '#ffd6d6', '#ffe2c2', '#fff1b8', '#dff2c2', '#c8ecd4', '#c2ece8',
  '#cde4f8', '#d6d9fb', '#e6d6f8', '#f8d4ec', '#e8dccb', '#dde3e8',
];
export const BLANK_ROW = { days: '', work: '', rest: '', note: '' };

const chosen = (wt) => {
  const color = String(wt.color || '').trim().toLowerCase();
  return /^#[0-9a-f]{6}$/.test(color) ? color : '';
};

// 색이 없는 타입에 아직 안 쓴 파스텔 색을 차례로 준다(지정한 색은 그대로)
export const fillColors = (list) => {
  const used = new Set(list.map(chosen));
  const free = WORK_TYPE_COLORS.filter((c) => !used.has(c));
  return list.map((wt, i) => ({ ...wt, color: chosen(wt) || (free.length ? free.shift() : WORK_TYPE_COLORS[i % WORK_TYPE_COLORS.length]) }));
};
// 새로 추가할 타입에 줄 색
export const nextColor = (list) => fillColors([...list, {}])[list.length].color;

// 샘플 이름이 이미 있으면 뒤에 번호를 붙인다
export const fromSample = (sample, list) => {
  const taken = new Set(list.map((w) => w.type));
  let type = sample.type;
  for (let n = 2; taken.has(type); n += 1) type = `${sample.type}${n}`;
  return { type, color: nextColor(list), rows: sample.rows.map((r) => ({ ...r })) };
};

function ColorPicker({ value, taken, onChange }) {
  const [open, setOpen] = useState(false);
  return (
    <span className="pps-color">
      <button type="button" className="pps-swatch current" style={{ background: value }} onClick={() => setOpen((v) => !v)} title="색 바꾸기" />
      {open && (
        <>
          <div className="pps-color-backdrop" onClick={() => setOpen(false)} />
          <div className="pps-color-pop">
            <div className="pps-swatches">
              {WORK_TYPE_COLORS.map((c) => {
                const busy = c !== value && taken.has(c);
                return (
                  <button
                    type="button"
                    key={c}
                    className={`pps-swatch ${c === value ? 'on' : ''}`}
                    style={{ background: c }}
                    disabled={busy}
                    title={busy ? '다른 근무타입이 쓰는 색입니다' : '이 색으로'}
                    onClick={() => { onChange(c); setOpen(false); }}
                  />
                );
              })}
            </div>
            <label className="pps-color-custom">
              직접 선택
              <input type="color" value={value} onChange={(e) => onChange(e.target.value)} />
            </label>
          </div>
        </>
      )}
    </span>
  );
}

// taken: 다른 근무타입이 쓰고 있는 색(Set)
function WorkTypeCard({ wt, taken, onChange, onRemove, autoFocus = false }) {
  const setRows = (rows) => onChange({ rows });
  return (
    <div className="pps-worktype" style={{ '--wt': wt.color }}>
      <div className="pps-worktype-head">
        <ColorPicker value={wt.color} taken={taken} onChange={(color) => onChange({ color })} />
        <input value={wt.type} placeholder="타입 이름" autoFocus={autoFocus} onChange={(e) => onChange({ type: e.target.value })} />
        {onRemove && <button type="button" className="pps-icon danger" onClick={onRemove} title="타입 제거">✕</button>}
      </div>
      <table className="pps-table">
        <thead><tr><th style={{ width: 110 }}>구분</th><th>근무시간</th><th>휴게시간</th><th>비고</th><th style={{ width: 40 }} /></tr></thead>
        <tbody>
          {wt.rows.map((r, k) => (
            <tr key={`r-${k}`}>
              {['days', 'work', 'rest', 'note'].map((f) => (
                <td key={f}>
                  <input value={r[f]} onChange={(e) => setRows(wt.rows.map((x, n) => (n === k ? { ...x, [f]: e.target.value } : x)))} />
                </td>
              ))}
              <td className="pps-actions">
                <button type="button" className="pps-icon danger" onClick={() => setRows(wt.rows.filter((_, n) => n !== k))} title="줄 제거">✕</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <button type="button" className="btn btn-secondary btn-sm" onClick={() => setRows([...wt.rows, { ...BLANK_ROW }])}>+ 줄 추가</button>
    </div>
  );
}

export default WorkTypeCard;
